<template>
  <div class="xy-image-editor">
    <div class="xy-image-editor-main" id="xy-image-editor"></div>
    <button @click="uploadImg" class="complate_button">保存</button>
    <button  class="complate_button select_button" @click="selectImage">选中</button>
    <div class="history_image">
      <img :src="item.file_url" @click="changeImage(item)" alt="" v-for="item in historyImage" :key="item.file_url">
    </div>
    <div class="progress_dialog" v-if="showProgress">
      <div class="progress_dialog_content">
        <progress-bar :options="options" :value="value"/>
        <!-- <span>上传中</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import "tui-image-editor/dist/tui-image-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
import CryptoJS from "crypto-js";
import ProgressBar from 'vuejs-progress-bar'
const ImageEditor = require("tui-image-editor");
const localeZh = {
  // override default English locale to your custom
  Crop: "裁剪",
  DeleteAll: "全部删除",
  Delete: "删除",
  Undo: "撤销",
  Redo: "反撤销",
  Reset: "重置",
  Flip: "镜像",
  Rotate: "旋转",
  Draw: "画",
  Shape: "形状标注",
  Icon: "图标标注",
  Text: "文字标注",
  Mask: "遮罩",
  Filter: "滤镜",
  Bold: "加粗",
  Italic: "斜体",
  Underline: "下划线",
  Left: "左对齐",
  Center: "居中",
  Right: "右对齐",
  Color: "颜色",
  "Text size": "字体大小",
  Custom: "自定义",
  Square: "正方形",
  Apply: "应用",
  Cancel: "取消",
  "Flip X": "X 轴",
  "Flip Y": "Y 轴",
  Range: "区间",
  Stroke: "描边",
  Fill: "填充",
  Circle: "圆",
  Triangle: "三角",
  Rectangle: "矩形",
  Free: "曲线",
  Straight: "直线",
  Arrow: "箭头",
  "Arrow-2": "箭头2",
  "Arrow-3": "箭头3",
  "Star-1": "星星1",
  "Star-2": "星星2",
  Polygon: "多边形",
  Location: "定位",
  Heart: "心形",
  Bubble: "气泡",
  "Custom icon": "自定义图标",
  "Load Mask Image": "加载蒙层图片",
  Grayscale: "灰度",
  Blur: "模糊",
  Sharpen: "锐化",
  Emboss: "浮雕",
  "Remove White": "除去白色",
  Distance: "距离",
  Brightness: "亮度",
  Noise: "噪音",
  "Color Filter": "彩色滤镜",
  Sepia: "棕色",
  Sepia2: "棕色2",
  Invert: "负片",
  Pixelate: "像素化",
  Threshold: "阈值",
  Tint: "色调",
  Multiply: "正片叠底",
  Blend: "混合色",
  // etc...
};
const customTheme = {
  // image 坐上角度图片
  "common.bi.image": "", // 在这里换上你喜欢的logo图片
  "common.bisize.width": "0px",
  "common.bisize.height": "0px",
  "common.backgroundImage": "none",
  "common.backgroundColor": "#333",
  "common.border": "1px solid #444",

  // header
  "header.backgroundImage": "none",
  "header.backgroundColor": "#f3f4f6",
  "header.border": "0px",
  "header.display": "none",

  // load button
  "loadButton.backgroundColor": "#fff",
  "loadButton.border": "1px solid #ddd",
  "loadButton.color": "#222",
  "loadButton.fontFamily": "NotoSans, sans-serif",
  "loadButton.fontSize": "12px",
  "loadButton.display": "none", // 可以直接隐藏掉

  // download button
  "downloadButton.backgroundColor": "#fdba3b",
  "downloadButton.border": "1px solid #fdba3b",
  "downloadButton.color": "#fff",
  "downloadButton.fontFamily": "NotoSans, sans-serif",
  "downloadButton.fontSize": "12px",
  "downloadButton.display": "none", // 可以直接隐藏掉

  // icons default
  "menu.normalIcon.color": "#8a8a8a",
  "menu.activeIcon.color": "#555555",
  "menu.disabledIcon.color": "#434343",
  "menu.hoverIcon.color": "#e9e9e9",
  "submenu.normalIcon.color": "#8a8a8a",
  "submenu.activeIcon.color": "#e9e9e9",

  "menu.iconSize.width": "22px",
  "menu.iconSize.height": "22px",
  "submenu.iconSize.width": "32px",
  "submenu.iconSize.height": "32px",

  // submenu primary color
  "submenu.backgroundColor": "#1e1e1e",
  "submenu.partition.color": "#858585",

  // submenu labels
  "submenu.normalLabel.color": "#858585",
  "submenu.normalLabel.fontWeight": "lighter",
  "submenu.activeLabel.color": "#fff",
  "submenu.activeLabel.fontWeight": "lighter",

  // checkbox style
  "checkbox.border": "1px solid #ccc",
  "checkbox.backgroundColor": "#fff",

  // rango style
  "range.pointer.color": "#fff",
  "range.bar.color": "#666",
  "range.subbar.color": "#d1d1d1",

  "range.disabledPointer.color": "#414141",
  "range.disabledBar.color": "#282828",
  "range.disabledSubbar.color": "#414141",

  "range.value.color": "#fff",
  "range.value.fontWeight": "lighter",
  "range.value.fontSize": "11px",
  "range.value.border": "1px solid #353535",
  "range.value.backgroundColor": "#151515",
  "range.title.color": "#fff",
  "range.title.fontWeight": "lighter",

  // colorpicker style
  "colorpicker.button.border": "1px solid #1e1e1e",
  "colorpicker.title.color": "#fff",
};
/**
 * 将对象转化为url形式
 * @param obj
 * @returns {string}
 */
const convertToURL = function (obj) {
  let result = "";
  if (obj !== null && typeof obj === "object") {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        let tmp = `&${key}=${obj[key]}`;
        result += tmp;
      }
    }
    result = result.substring(1);
  }
  return result;
};
export default {
  name: "xy-image-editor",
  components: {ProgressBar},
  props: {
    imageSrc: {
      type: String,
      default: "",
    },
    accessKeyId: {
      type: String,
      default: "ampClNgAhhGyDOjhxzMu",
    },
    secretKey: {
      type: String,
      default: "RriRpHeQoCeCtdNDLvxb",
    },
    bucket: {
      type: String,
      default: "editpic",
    },
    host: {
      type: String,
      default: "https://my-dev.aihoge.com",
    },
  },
  data () {
    return {
      historyImage: [],
      options: {
        progress: {
          color: '#2dbd2d',
          backgroundColor: '#333333',
          inverted: false
        },
        layout: {
          height: 100,
          width: 110,
          // verticalTextAlign: 61,
          // horizontalTextAlign: 43,
          // zeroOffset: 0,
          strokeWidth: 10,
          // progressPadding: 0,
          type: 'circle'
        }
      },
      value: 0,
      showProgress: false
    }
  },
  created () {
    this.getHistoryList()
  },
  computed: {
    filename () {
      let arr = this.imageSrc.split('.')
      let str = arr[arr.length - 2]
      let narr = str.split('/')
      let nstr = narr[narr.length - 1]
      if (nstr.includes('-')) {
        nstr = nstr.split('-')[0]
      }
      return nstr
    },
    historyImageLength () {
      return this.historyImage.length
    }
  },
  watch: {
    historyImageLength (val) {
      if (val) {
        let ele = document.querySelector('.tui-image-editor-align-wrap')
        ele.style.position = 'absolute'
        ele.style.top = 0
        ele.style.left = '150px'
        ele.style.bottom = 0
        ele.style.right = 0
        ele.style.display = 'flex'
        ele.style.justifyContent = 'center'
        ele.style.alignItems = 'center'
      }
    }
  },
  mounted() {
    this.instance = new ImageEditor(
      document.querySelector("#xy-image-editor"),
      {
        includeUI: {
          loadImage: {
            path: this.imageSrc,
            name: "image",
          },
          initMenu: "",
          menuBarPosition: "top",
          locale: localeZh,
          theme: customTheme,
        },
      }
    );
  },
  methods: {
    getHistoryList () {
      let xhr = new XMLHttpRequest();
      let url = this.host + "/api/filestorage/controlFileUrlList?file_url=" + this.imageSrc
      let timestap = parseInt(new Date().getTime() / 1000);
      let cryptoArr = CryptoJS.HmacSHA1("" + timestap, this.secretKey);
      let crytoStr = cryptoArr.toString(CryptoJS.enc.Base64);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {
          var respone = JSON.parse(xhr.responseText);
          if (respone.result && respone.result) {
            let result = respone.result
            result.forEach(e => {
              this.historyImage.push({
                file_url: e
              })
            })
          }
        }
      };
      xhr.open("get", url, true);
      xhr.setRequestHeader("timestamp", timestap);
      xhr.setRequestHeader(
        "filestorage-authorization",
        this.accessKeyId + ":" + crytoStr
      );
      xhr.send()
    },
    changeImage (item) {
      this.instance.loadImageFromURL(item.file_url, 'aaa')
    },
    selectImage () {
      const base64String = this.instance.toDataURL();
      const data = window.atob(base64String.split(",")[1]);
      const ia = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/png" });
      this.upload(blob).then((res) => {
        this.$emit("editor-complate", res.result);
      })
    },
    uploadImg () {
      const base64String = this.instance.toDataURL();
      const data = window.atob(base64String.split(",")[1]);
      const ia = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/png" });
      // this.$emit("editor-complate", { base64: base64String, blob: blob });
      this.upload(blob);
    },
    upload(file) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        let timestap = parseInt(new Date().getTime() / 1000);
        let cryptoArr = CryptoJS.HmacSHA1("" + timestap, this.secretKey);
        let crytoStr = cryptoArr.toString(CryptoJS.enc.Base64);
        let fd = new FormData();
        fd.append("file", file);
        let url =
          this.host +
          "/api/filestorage/normalUpload/?bucket=" +
          this.bucket +
          "&object_key=" +
          this.filename +
          ".png";
        xhr.open("post", url, true);
        xhr.setRequestHeader("timestamp", timestap);
        xhr.setRequestHeader(
          "filestorage-authorization",
          this.accessKeyId + ":" + crytoStr
        );
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {
            var respone = JSON.parse(xhr.responseText);
            this.historyImage.push(respone.result);
            xhr.onreadystatechange = new Function();
            xhr = null;
            resolve(respone);
          }
        };
        this.showProgress = true
        xhr.upload.onprogress = (e) => {
            this.value = Math.ceil((e.loaded / e.total)*100)
            if (this.value >= 100) {
              this.showProgress = false
              this.value = 0
            }
        }
        xhr.send(fd);
      })
    },
  },
};
</script>

<style lang='scss'>
.xy-image-editor {
  width: 100%;
  height: 100%;
  position: relative;
  .xy-image-editor-main {
    width: 100%;
    height: 100%;
    .tui-image-editor-main {
      //   top: 0;
    }
  }
  .history_image {
    position: absolute;
    top: 80px;
    left: 10px;
    display: flex;
    flex-direction: column;
    bottom: 40px;
    overflow: auto;
    img {
      width: 120px;
      height: auto;
      max-height: 120px;
      margin-bottom: 20px;
      object-fit: contain;
      cursor: pointer;
    }
  }
  .complate_button {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 6px 12px;
    border-radius: 4px;
    border: none;
    background: #dbecff;
    color: #037aff;
    cursor: pointer;
    z-index: 20;
  }
  .select_button {
    right: 80px;
  }
  .progress_dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255,0.5);
    z-index: 100;
    .progress_dialog_content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/xy-image-editor.vue